mainApp.directive('toggleBtn', function () {
	return {
		scope: {
		    buttonClass: "=?",
		},
		templateUrl: '/public/directives/toggleBtn.html',
	}
});